import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import { getCategorySales, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import { reportCategorySales } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
// import { Bar } from "Recharts";
import WithRouter from 'custom/withRouter';
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class CategorySales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            },
            categoryList: [],
            dataForPlotting: [],
            exceedPlotRange: false
        };
        this.showBody = this.showBody.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `CategorySalesBeginDate`);
        this.props.formInput(date, `CategorySalesEndDate`);
    }

    filter() {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport() {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let branchIds = this.props.branch || this.props.loggedBranch;
        let dateGroupBy = this.props.reportBy;
        let isCannabis = this.props.isCannabis;
        let categoryId = 0;//this.props.categoryId;
        let includeCategoryData = 1;
        let includeProductData = 1;
        this.props.getCategorySales({ beginDate, endDate, branchIds, isCannabis, categoryId, dateGroupBy, includeCategoryData, includeProductData });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    downloadReport() {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : moment().add('day').format('YYYY-MM-DD');
        let branchIds = this.props.branch || this.props.loggedBranch;
        let dateGroupBy = this.props.reportBy;
        let isCannabis = this.props.isCannabis;
        let categoryId = 0;//this.props.categoryId;
        let includeCategoryData = 1;
        let includeProductData = this.props.includeProducts ? 1 : 0;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/categorysales?beginDate=${beginDate}&EndDate=${endDate}&branchIds=${branchIds}&isCannabis=${isCannabis}&categoryId=${categoryId}&dateGroupBy=${dateGroupBy}&includeCategoryData=${includeCategoryData}&includeProductData=${includeProductData}`, "categorysales");
        }
    }

    redirectToReport() {
        this.props.navigate("/report");
    }


    render() {
        return (
            <Grid headerContent={reportCategorySales}>
                <PageHeader 
                    title={LOOKUP.report.categorysales.text} 
                    description={LOOKUP.report.categorysales.description} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-sales-by-category-report" />} 
                />
                <Header
                    showBody={this.showBody}
                    download={this.downloadReport}
                    loggedBranch={this.props.loggedBranch}
                    group={this.props.groupbyOption}
                />
                {this.state.showBody &&
                    <React.Fragment>
                        <DateCurrentDisplay />
                        <CardSimple>
                            <Body
                                categorySales={this.props.categorySales}
                                beginDate={this.props.beginDate}
                                endDate={this.props.endDate}
                                loggedBranch={this.props.loggedBranch}
                                branchForm={this.props.branch}
                            />
                        </CardSimple>
                    </React.Fragment>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let Groups =
        [
            { text: "Daily", value: "Day" },
            { text: "Weekly", value: "Week" },
            { text: "Monthly", value: "Month" }
        ];
    return {
        brachOptions: brachOptions,
        categorySales: state.reports.categorySales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.CategorySalesBeginDate,
        endDate: state.form.CategorySalesEndDate,
        branch: state.form.CategorySalesBranchOption,
        groupbyOption: Groups,
        reportBy: state.form.CategorySalesReportBy,
        isCannabis: state.form.CategorySalesIsCannabis,
        includeProducts: state.form.CategorySalesIncludeProducts
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCategorySales: model => dispatch(getCategorySales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CategorySales));